<template>
	<div class="activity">
		<p class="activity__title">
			Activity Time Stamp
		</p>

		<ul class="activity__list">
			<li class="activity__item" v-for="(item, index) in activities" :key="index">
				<p>
					<span class="activity__label">Time:</span>
					{{ item.created_at | moment('hh:mm: A') }}
				</p>

				<p>
					<span class="activity__label">Activity:</span>
					{{ item.activity }}
				</p>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	props: {
		activities: {
			type: Array
		}
	}
}
</script>

<style lang="scss" scoped>
.activity {
	width: 100%;

	&__title {
		border-bottom: 1px solid #ccc;
		padding-bottom: 10px;
	}

	&__list {
		list-style: none;
	}

	&__item {
		padding: 10px;
		margin-bottom: 10px;
	}

	&__label {
		display: inline-block;
		width: 150px;
	}

	p {
		margin-bottom: 10px;
	}
}
</style>
